// extracted by mini-css-extract-plugin
export var btn = "D_mD v_r7 v_rS d_bw d_bL d_bz d_ds";
export var full = "D_tV d_s d_D";